module.exports = __webpack_public_path__ + "img/icon-task.5cc3f4af.svg";